export enum OrganizationAddressLabels {
  PRIMARY = 0,
  SECONDARY,
  BILLING,
}

export class Address {
  id = "";

  first_line = "";

  second_line = "";

  city = "";

  state = "";

  zip_code: number = 10000;
}

export class AddressEntry {
  organization_id = "";

  user_id: string | null = "";

  address_id = "";

  label: OrganizationAddressLabels = OrganizationAddressLabels.PRIMARY;

  id = "";
}

export const validateAddress = (address?: Address) => {
  return (
    !!address &&
    address.first_line &&
    address.city &&
    address.state &&
    address.zip_code
  );
};

export function parseAddressFromString(input: string): Address | undefined {
  const parts = input.split(",").map((p) => p.trim());
  let first_line = "";
  let city = "";
  let state = "";
  let zip_code = 0;
  if (parts.length === 4) {
    [first_line, city, state, zip_code] = [
      parts[0],
      parts[1],
      parts[2],
      Number(parts[3]) || 0,
    ];
  } else if (parts.length === 3) {
    [first_line, city, state] = [parts[0], parts[1], parts[2]];
  } else {
    return undefined;
  }
  return {
    id: "manual-entry",
    first_line,
    second_line: "",
    city,
    state: state || "",
    zip_code,
  };
}

export const addressToString = (address?: Address) => {
  if (!address) return "";
  const parts = [];
  if (address.first_line) parts.push(address.first_line);
  if (address.second_line && address.second_line !== "")
    parts.push(address.second_line);
  if (address.city) parts.push(address.city);
  if (address.state) parts.push(address.state);
  if (address.zip_code && address.zip_code !== 0)
    parts.push(address.zip_code.toString());
  return parts.join(", ");
};
